import React, { useState } from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import UbicacionSearch from './UbicacionSearch';
import { IUbicacion } from '../interfaces/Ubicacion';

interface Props {
  value: string;
  onChange: (value: string, nroUbicacion?: number) => void;
  disabled?: boolean;
  size?: 'small' | 'medium';
  label?: string;
  fullWidth?: boolean;
}

const UbicacionSelector: React.FC<Props> = ({
  value,
  onChange,
  disabled = false,
  size = 'small',
  label = 'Dirección / Depósito destino',
  fullWidth = true,
}) => {
  const [open, setOpen] = useState(false);

  const handleSelect = (ub: IUbicacion) => {
    onChange(`${ub.nombreUbicacion?.trim()} (${ub.nroUbicacion})`, ub.nroUbicacion);
  };

  return (
    <>
      <TextField
        label={label}
        size={size}
        fullWidth={fullWidth}
        value={value}
        placeholder="Seleccionar ubicación..."
        InputProps={{
          readOnly: true,
          endAdornment: !disabled && (
            <InputAdornment position="end">
              {value && (
                <IconButton edge="end" size="small" onClick={() => onChange('', undefined)}>
                  <ClearIcon fontSize="small" />
                </IconButton>
              )}
              <IconButton edge="end" size="small" onClick={() => setOpen(true)}>
                <SearchIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
        onClick={() => !disabled && !value && setOpen(true)}
        sx={{ cursor: disabled ? 'default' : 'pointer', '& .MuiInputBase-input': { cursor: 'pointer' } }}
      />
      <UbicacionSearch open={open} onClose={() => setOpen(false)} onSelect={handleSelect} />
    </>
  );
};

export default UbicacionSelector;
